(function () {
  const root = document.querySelector('.lo-hsl')
  if (!root) return
  const slides = root.querySelectorAll('.lo-hsl-slide')
  const dots = root.querySelectorAll('.lo-hsl-dot')
  const arrows = root.querySelectorAll('.lo-hsl-arrow')
  if (slides.length < 2) return

  let current = 0
  const total = slides.length
  const interval = (parseInt(root.dataset.interval, 10) || 6) * 1000
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  let autoplay = root.dataset.autoplay === 'true' && !reduceMotion.matches
  let timer = null

  function show (index) {
    slides.forEach(function (slide, i) {
      const isCurrent = i === index
      slide.classList.toggle('active', isCurrent)
      slide.inert = !isCurrent
      slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true')
    })
    dots.forEach(function (dot, i) {
      dot.classList.toggle('active', i === index)
    })
    current = index
  }

  function next (dir) {
    const nextIndex = (current + dir + total) % total
    show(nextIndex)
    restart()
  }

  function restart () {
    if (!autoplay) return
    clearInterval(timer)
    timer = setInterval(function () {
      next(1)
    }, interval)
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      show(i)
      restart()
    })
  })

  arrows.forEach(function (a) {
    a.addEventListener('click', function () {
      next(parseInt(a.dataset.dir, 10))
    })
  })

  /*
     It could only be changed with the arrows and the dots. On a phone, which is where a
     swipe is expected, nothing happened: the slides are stacked layers that cross-fade,
     so the browser has no rail to drag and the gesture has to be read. A tap still
     opens the slide's link; the click is only cancelled when there really was a drag,
     so the slide just left behind does not open.
  */
  const track = root.querySelector('.lo-hsl-track')
  if (track) {
    /*
       On iOS the browser decides very early whether the gesture is its own. If the
       finger starts with any tilt it keeps it to scroll the page and sends
       pointercancel: the whole swipe was lost, which is why it was harder on some
       phones than others. The travel is measured in pointermove now, so by the time
       the cancel arrives it is already known whether the horizontal dominated, and it
       is handled anyway.
    */
    const THRESHOLD = 28 /* the travel of an unhurried swipe */
    const FLICK = 14 /* a quick flick travels less and is just as deliberate */
    const FLICK_MS = 320
    let startX = null
    let startY = null
    let startTime = 0
    let deltaX = 0
    let deltaY = 0
    let horizontal = false
    let dragged = false

    function begin (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return
      startX = e.clientX
      startY = e.clientY
      startTime = Date.now()
      deltaX = 0
      deltaY = 0
      horizontal = false
      dragged = false
    }

    function goTo (e) {
      if (startX === null) return
      deltaX = e.clientX - startX
      deltaY = e.clientY - startY
      /* It is enough that the horizontal dominates: a finger almost never goes straight. */
      if (Math.abs(deltaX) > 10 && Math.abs(deltaX) >= Math.abs(deltaY)) horizontal = true
    }

    function release (cancelled) {
      if (startX === null) return
      const elapsed = Date.now() - startTime
      startX = null
      startY = null
      const farEnough =
        Math.abs(deltaX) > THRESHOLD || (elapsed < FLICK_MS && Math.abs(deltaX) > FLICK)
      /*
         If the browser kept the gesture it is only handled when the horizontal
         already dominated, so the slide does not change while the page is
         scrolling.
      */
      if (farEnough && (horizontal || (!cancelled && Math.abs(deltaX) > Math.abs(deltaY)))) {
        dragged = true
        next(deltaX < 0 ? 1 : -1)
      }
    }

    track.addEventListener('pointerdown', begin)
    track.addEventListener('pointermove', goTo)
    track.addEventListener('pointerup', function (e) {
      goTo(e)
      release(false)
    })
    track.addEventListener('pointercancel', function () {
      release(true)
    })

    track.addEventListener(
      'click',
      function (e) {
        if (!dragged) return
        dragged = false
        e.preventDefault()
        e.stopPropagation()
      },
      true
    )
  }

  function stop () {
    clearInterval(timer)
  }

  root.addEventListener('pointerenter', stop)
  root.addEventListener('pointerleave', restart)
  root.addEventListener('focusin', stop)
  root.addEventListener('focusout', function (e) {
    if (!root.contains(e.relatedTarget)) restart()
  })

  show(0)
  if (autoplay) restart()

  reduceMotion.addEventListener('change', function () {
    autoplay = root.dataset.autoplay === 'true' && !reduceMotion.matches
    if (autoplay) {
      restart()
    } else {
      clearInterval(timer)
    }
  })
})()
